export type AssetEntry = {
  type: "image" | "audio" | "font" | "data";
  path: string;
};

export type AssetPackManifest = {
  schemaVersion: number;
  packId: string;
  name: string;
  version: string;
  author: string;
  license: string;
  minimumGameVersion: string;
  assets: Record<string, AssetEntry>;
  localization?: Record<string, string>;
};

export const REQUIRED_ASSET_IDS = [
  "ui.inventory_slot",
  "ui.crafting_grid",
  "ui.timer_frame"
] as const;

export class AssetResolver {
  constructor(
    private readonly manifest: AssetPackManifest,
    private readonly baseUrl: string
  ) {}

  resolve(assetId: string): string {
    const entry = this.manifest.assets[assetId];
    if (!entry) throw new Error(`Missing asset: ${assetId}`);
    return `${this.baseUrl.replace(/\/$/, "")}/${entry.path}`;
  }
}

export function getItemAssetKey(itemId: string): string {
  return `item.${itemId}`;
}

export async function loadAssetPack(baseUrl = "/fallback"): Promise<{ manifest: AssetPackManifest; resolver: AssetResolver }> {
  const response = await fetch(`${baseUrl}/pack.json`);
  if (!response.ok) throw new Error(`Asset pack failed to load (${response.status})`);
  const manifest = (await response.json()) as AssetPackManifest;
  return { manifest, resolver: new AssetResolver(manifest, baseUrl) };
}
